module.exports = __webpack_public_path__ + "img/logo.eb57b934.png";